import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import admin from './modules/admin';
import teacher from './modules/teacher';
import parent from './modules/parent';
import student from './modules/student';

Vue.use(Vuex);

// 判断初始侧边栏状态 - 移动端默认折叠
const isMobile = window.innerWidth < 768;

export default new Vuex.Store({
  state: {
    // 全局共享状态
    appName: process.env.VUE_APP_TITLE || '校园管理系统',
    appVersion: '1.0.0',
    isCollapse: true, // 默认折叠，由组件在mounted时根据设备类型自行展开
    currentCampus: null
  },
  mutations: {
    // 修改全局状态的同步方法
    SET_COLLAPSE(state, isCollapse) {
      state.isCollapse = isCollapse;
    },
    SET_CURRENT_CAMPUS(state, campus) {
      state.currentCampus = campus;
      localStorage.setItem('currentCampus', JSON.stringify(campus));
    }
  },
  actions: {
    // 异步操作和业务逻辑
    toggleSidebar({ commit, state }) {
      commit('SET_COLLAPSE', !state.isCollapse);
    },
    setCampus({ commit }, campus) {
      commit('SET_CURRENT_CAMPUS', campus);
    }
  },
  getters: {
    // 计算属性
    currentCampusName: state => {
      return state.currentCampus ? state.currentCampus.name : '未选择校区';
    },
    isCampusSelected: state => {
      return !!state.currentCampus;
    },
    isCollapse: state => {
      return state.isCollapse;
    }
  },
  modules: {
    // 模块化状态管理
    auth,
    admin,
    teacher,
    parent,
    student
  }
}); 